<script setup>
import { defineProps } from 'vue';
const props = defineProps({
    code: String
});
import utilHelper from "../../app/utilHelper";
const {getPjLogoImagePath} = utilHelper();
</script>

<template>
    <div id="header" class="uk-flex uk-width-1-1">
        <router-link to="/">
            <div id="icon-area" class="uk-flex uk-margin-small-left">
                <img :src="getPjLogoImagePath(code)" alt="icon" class=""/>
            </div>
        </router-link>
        <div id="title" class="uk-display-inline-block">
            アカウント復旧依頼フォーム
        </div>
    </div>
</template>

<style scoped>
#header {
    height: var(--header-height);
    background: var(--common-background);
    #title {
        margin: auto 0 auto 10px;
        color: var(--text-color-white);
        font-size: 0.9em;
    }
}
#icon-area {
    width: var(--header-height);
    height: var(--header-height);
}
</style>